<template>
	<div class="inner-modal inner-modal--acc">
		<div class="acc">
			<div class="acc__inner">
				<div class="acc__form">
					<div class="acc__head">
						<h3 class="acc__heading">Login to Your Account</h3>
						<template v-if="validationErrors.length">
							<template v-for="error in validationErrors">
								<p class="text-danger text-center">{{error}}</p>
							</template>
						</template>
					</div>
					<div class="form-group">
						<label for="emailAddress">Email address<span class="text-danger">*</span></label>
						<input type="email" v-model="loginInfo.emailAddress" id="emailAddress" :class="[`form-control`, formValidationErrors?.emailAddress?.length ? 'is-invalid' : '']">
						<div class="invalid-feedback" v-for="error in formValidationErrors?.emailAddress">
							&bull; {{error}}
						</div>
					</div>
					<div class="form-group">
						<label for="password">Password<span class="text-danger">*</span></label>
						<input type="password" v-model="loginInfo.password" id="password" :class="[`form-control`, formValidationErrors?.password?.length ? 'is-invalid' : '']">
						<div class="invalid-feedback" v-for="error in formValidationErrors?.password">
							&bull; {{error}}
						</div>
					</div>
					<div class="text-center mt-3">
						<Cta type="primary" size="lg" label="Login" @onClick="login" :icon="[]" iconAlignment="left"> </Cta>
					</div>
				</div>
				<div class="acc__more">
					<Cta type="outline" size="lg" label="Create New Account" @onClick="createAccount" :icon="[]" iconAlignment="left"> </Cta>
					<Cta type="outline" size="lg" label="Forgot Password" @onClick="forgotPassword" :icon="[]" iconAlignment="left"> </Cta>
				</div>
			</div>
		</div>
		<button @click="closeModal" class="inner-modal__close">&times;</button>
	</div>
</template>

<script lang="ts" setup>
import { computed, ref, onMounted } from 'vue';
import { LockDesignerUserLoginRequest } from 'Vue/interfaces/LockDesigner';
import {UserLogin, WishlistItems} from 'Api/apis';
const componentName = 'AccountRegistrationModal';
import { useStore } from 'vuex';
const store = useStore();
import { useRouter } from 'vue-router';
const router = useRouter();
import { useToast } from 'vue-toastification';
import Cta from "Vue/components/lockDesigner/components/shared/Cta.vue";
const toast = useToast();
const validationErrors = ref<string[]>([]);
const formValidationErrors = ref<any>({});

const props = defineProps({
	forwardingRoute: String,
	closeModal: Boolean,
	pathPrefix: String
});

const loginInfo = ref<{ emailAddress: string, password: string }>({
	emailAddress: "",
	password: ""
});

const saveToLocalStorage = async(value) => {
	await localStorage.setItem('authToken', value);
};

const login = async() => {
	await UserLogin(loginInfo.value).then(async(response) => {
		if(response.data) {
			await store.commit('updateAuthToken', response.data.authToken);
			await router.push(props.forwardingRoute);

			let wliResponse = await WishlistItems({wishlistName: ''}, store?.state?.authToken);

			if(!response.isErrors) {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'wishlistUser',
					data: wliResponse.data?.username
				});
			}

			if(props.closeModal) {
				await store.dispatch('closeModal');
			}
		} else {
			if(response.isErrors) {
				if(response.errorDetail.isError) {
					validationErrors.value = response.userFriendlyMessages;
				}
				if(response.formValidationMessages) {
					formValidationErrors.value = response.formValidationMessages;
				}
			}

		}
	});
};

const createAccount = async() => {
	await router.push(`${props.pathPrefix}/register`);
}

const forgotPassword = async() => {
	await router.push(`${props.pathPrefix}/forgot-password`);

};
const closeModal = async() => {
	await store.dispatch('closeModal');
};
</script>
